import { OHLCData } from "../interface/httpResponse";

export enum PointTypeEnum {
    OPEN = 1,
    HIGH = 2,
    LOW = 3,
    CLOSE = 4
}

export class PointType {

    public static getByValue(value: number | undefined) {
        switch(value) {
            case 1:
                return PointTypeEnum.OPEN;
            case 2:
                return PointTypeEnum.HIGH;
            case 3:
                return PointTypeEnum.LOW;
            case 4:
                return PointTypeEnum.CLOSE;
            default:
                return PointTypeEnum.CLOSE;
        }
    }

    public static getValueByPointType(ohlc: OHLCData, point: PointTypeEnum) {
        switch(point) {
            case PointTypeEnum.OPEN:
                return ohlc.open!;
            case PointTypeEnum.HIGH:
                return ohlc.high!;
            case PointTypeEnum.LOW:
                return ohlc.low!;
            case PointTypeEnum.CLOSE:
                return ohlc.close!;
        }
    }

}